export default "__VITE_ASSET__AbuvsgtN__"